import Lockr from 'lockr'

import Vue from 'vue'

const lockr_prefix = 'lockr_manban_'

// import store from '@/store'

Lockr.prefix = lockr_prefix
export function lockrSet (prop, val) {
  Lockr.set(prop, val)
}

export function lockrGet (prop, defaultVal) {
  // If value is null or undefined it returns a defaultVal
  // const new_prop = lockr_prefix + prop

  // console.log(new_prop, 'new_prop')

  // console.log(Lockr.getAll(true))
  // console.log(Lockr.get(prop), 'prop get')
  // console.log(Lockr.get(new_prop), 'new_prop get')

  // lockrFlush()

  return Lockr.get(prop, defaultVal)
}

export function lockrRm (prop) {
  // const new_prop = lockr_prefix + prop

  Lockr.rm(prop)
}

export function lockrGetAll (includesKeys) { // includesKeys: Boolean true 带有key false 不带key
  Lockr.getAll(includesKeys)
}

export function lockrFlush () {
  Lockr.flush()
}

export function lockrUserStoreSet (data) {
  const key = generateUserKey()

  Lockr.set(key, {...(lockrUserStoreGet() || {}), ...(data || {})}) // 对象内多个属性增删改
  // Lockr.set(key, data)
}

export function lockrUserStoreGet () {
  const key = generateUserKey()

  return Lockr.get(key)
}

function generateUserKey () {
  const profile_id = Vue.prototype.$cookies.get('profileid') || ''

  const org_id = Vue.prototype.$cookies.get('orgid') || ''

  return `orgid=${org_id}__userid=${profile_id}`
}

export default {
  lockrSet,
  lockrGet,
  lockrRm,
  lockrGetAll,
  lockrFlush,
  lockrUserStoreSet,
  lockrUserStoreGet
}
